import React from 'react';
import { connect } from 'react-redux';
import { getProductRegistryById, getSelectedProduct } from '@americanexpress/product-ducks';
import { Selectors } from '@americanexpress/axp-benefits-utils';
import { fromJS } from 'immutable';
import Terms from '../new/terms/components/TermsPage';
import useOneData from '../hooks/useOneData';
import { getEndpoint, getReadBenefitsRequestBody } from '../api/api-utils';
import { ReadLoyaltyBenefitsVx } from '../constants';

export function getBenefitTerms(cardproduct, benefits) {
  let benefitTerms = '';
  let assuranceDisclosures = '';
  let disclosureHeader = '';
  let disclosureContent = '';

  // Loop through each ordered benefit
  for (let b = 0; b < cardproduct?.benefitsOrderList.length; b += 1) {
    const benefit = cardproduct?.benefitsOrderList[b];

    // Inner loop through each disclosure for that benefit
    if (benefits[benefit]?.disclosures && benefits[benefit]?.disclosures.length > 0) {
      for (let d = 0; d < benefits[benefit]?.disclosures.length; d += 1) {
        disclosureHeader = benefits[benefit]?.disclosures[d]?.title;
        disclosureContent = benefits[benefit]?.disclosures[d].content;

        if (benefits[benefit]?.disclosures[d]?.type === 'BENEFIT_TERMS') {
          benefitTerms += `<div class="font-weight-bold">${disclosureHeader && disclosureHeader}</div><br />${disclosureContent}<br /><br />`;
        } else if (benefits[benefit]?.disclosures[d]?.type === 'ASSURANCE_DISCLOSURES') {
          assuranceDisclosures += `<div class="font-weight-bold">${disclosureHeader && disclosureHeader}</div><br />${disclosureContent}<br /><br />`;
        }
      }
    }
  }
  return {
    benefitTerms,
    assuranceDisclosures,
  };
}

export function TermsWrapper(properties) {
  const parameters = properties?.params || {};
  const cardNameState = properties?.cardNameState;
  const cardNameParams = parameters?.cardname;

  const getCardNameFromState = cardNameState?.data?.cardDetails?.cardName;
  const cardNameValueToUse = getCardNameFromState || cardNameParams;

  const faasApiUrl = properties?.faasApiUrl;
  const accountToken = properties?.accountToken;
  const endpoint = getEndpoint(faasApiUrl, ReadLoyaltyBenefitsVx);
  const login = properties?.login;
  const productType = properties?.productType;

  const requestBody = getReadBenefitsRequestBody(accountToken, cardNameValueToUse, login, productType);
  const endpointOptions = {
    body: requestBody,
  };

  const {
    isLoading: loadingReadLoyaltyBenefits,
    data: readLoyaltyBenefits,
    error: readLoyaltyBenefitsError,
  } = useOneData(endpoint, endpointOptions);

  const getDisclosures = getBenefitTerms(readLoyaltyBenefits?.cardProduct, readLoyaltyBenefits?.benefits);

  return (
    <Terms
      {...properties}
      cardNameValueToUse={cardNameValueToUse}
      loadingReadLoyaltyBenefits={loadingReadLoyaltyBenefits}
      readLoyaltyBenefits={readLoyaltyBenefits}
      readLoyaltyBenefitsError={readLoyaltyBenefitsError}
      benefitTerms={getDisclosures.benefitTerms}
      assuranceDisclosures={getDisclosures.assuranceDisclosures}
    />
  );
}

export function mapStateToProps(state) {
  const product = getSelectedProduct(state);
  return {
    cardNameState: Selectors.getCardNameFromState(state),
    locale: fromJS(state).getIn(['intl', 'activeLocale']),
    faasApiUrl: fromJS(state).getIn(['config', 'faasApiUrl']),
    accountToken: getSelectedProduct(state),
    login: Boolean(getSelectedProduct(state)),
    productType: getProductRegistryById(state, product)?.type,
  };
}

export default connect(mapStateToProps, null)(TermsWrapper);
